module.exports = __webpack_public_path__ + "static/media/angelo.462c4e20.png";